import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { TableRow } from '@mui/material'
import React from 'react'

const OrganizationHeader = (): JSX.Element => {
  return (
    <TableRow>
      <TableHeaderCell minWidth={TableCellWidth.EXTRA_SMALL} label="Id" />
      <TableHeaderCell label="Name" />
      <TableHeaderCell label="VatNr" />
      <TableHeaderCell label="Website" />
      <TableHeaderCell label="Solution" />
      <TableHeaderCell label="Allowed AI Screenings" />
      <TableHeaderCell label="Contracted Users" />
      <TableHeaderCell label="Actual Users" />
      <TableHeaderCell label="Contracted Suppliers" />
      <TableHeaderCell label="Actual Suppliers" />
    </TableRow>
  )
}

export default OrganizationHeader
